import api from './api';

class CountryService {
  /**
   * Get all countries
   * @returns {Promise} API response
   */
  async getAllCountries() {
    try {
      const response = await api.get('/countries/list-all');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Search countries by name
   * @param {string} name - Search query
   * @returns {Promise} API response
   */
  async searchCountries(name = '') {
    try {
      const params = name ? `?name=${encodeURIComponent(name)}` : '';
      const response = await api.get(`/countries/search${params}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Create new country
   * @param {Object} data - Country data
   * @returns {Promise} API response
   */
  async createCountry(data) {
    try {
      const response = await api.post('/countries/create-country', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

const countryService = new CountryService();
export default countryService;